import { Outlet } from 'react-router-dom';
import React, {useState, useLayoutEffect, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import LeftHeader from '../../generals-components/headers/left-header';
import Footer from '../../generals-components/footer/footer';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function getUserPendingRequests() {
    if (document.hidden) return;

    const response = await fetch('/api/get-account-pending-requests', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function getUserFriends() {
    if (document.hidden) return;

    const response = await fetch('/api/get-account-friends', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function setUserNotifications(value) {
    if (document.hidden) return;

    const response = await fetch('/api/set-account-notifications', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            value: value
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

function AccountFriendsLayout() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [userPendingFriends, setUserPendingFriends] = useState(null);
    const [userCurrentFriends, setUserCurrentFriends] = useState(null);
    const [userFriendCode, setUserFriendCode] = useState("")

    const [isUserLogged, setIsUserLogged] = useState(false)

    const fetchFriends = async () => {
        var pending_requests = await getUserPendingRequests()
        if (pending_requests === null) {
            setUserPendingFriends("")
        } else {
            setUserPendingFriends(pending_requests)
        }

        var friends = await getUserFriends()
        if (friends === null) {
            setUserCurrentFriends("")
        } else {
            setUserCurrentFriends(friends)
        }

        await setUserNotifications("0")
    };

    useLayoutEffect(() => {
        const startFriends = async () => {
            var data = await getUserData()
            if (!data) {
                navigate('/login');
            } else {
                setUserData(data)
                setUserFriendCode(data.friendCode)
            }

            await fetchFriends();
        };

        startFriends()
    }, [navigate])

    useLayoutEffect(() => {
        async function checkIfUserIsLogged() {
            setIsUserLogged(await checkUserSession())
        }

        checkIfUserIsLogged()
    }, [])

    useEffect(() => {
        const interval = setInterval(async () => {
            await fetchFriends();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    if (userData !== null && userPendingFriends !== null) {
        return (
            <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root">
                <div className="layout-container flex h-full grow flex-col">
                    <LeftHeader isUserLogged={isUserLogged} setIsUserLogged={setIsUserLogged} currentPage={"Friends"}/>

                    <Outlet context={{userPendingFriends, userCurrentFriends, userFriendCode}}/>

                    <Footer currentPage={"Friends"}/>
                </div>
            </div>
        );
    }
}

export default AccountFriendsLayout;